import {Store, StoreConfig} from "@datorama/akita";
import {AuthState, initialState} from "./models";

@StoreConfig({name: 'auth'})
export class AuthStore extends Store<AuthState> {
    constructor() {
        super(initialState());
    }
}